import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "filename"]

  connect() {
    // Set up initial styling
  }

  dragover(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add("border-blue-500", "bg-blue-50", "dark:bg-blue-900/20")
  }

  dragenter(event) {
    event.preventDefault()
  }

  dragleave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-blue-500", "bg-blue-50", "dark:bg-blue-900/20")
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove("border-blue-500", "bg-blue-50", "dark:bg-blue-900/20")

    const files = event.dataTransfer.files
    if (files.length > 0 && files[0].name.endsWith('.csv')) {
      this.inputTarget.files = files
      this.updateFilename(files[0].name)
    } else {
      alert("Please upload a CSV file")
    }
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (file) {
      this.updateFilename(file.name)
    }
  }

  updateFilename(name) {
    if (this.hasFilenameTarget) {
      this.filenameTarget.textContent = `Selected: ${name}`
      this.filenameTarget.classList.add("text-green-600", "dark:text-green-400")
    }
  }
}
